export const GET_TIMELINE_REQUEST = 'GET_TIMELINE_REQUEST';
export const GET_TIMELINE_SUCCESS = 'GET_TIMELINE_SUCCESS';
export const GET_TIMELINE_ERROR   = 'GET_TIMELINE_ERROR';
export const GET_MORE_TIMELINE_SUCCESS = 'GET_MORE_TIMELINE_SUCCESS'

export const REMOVE_TIMELINE_REQUEST = 'REMOVE_TIMELINE_REQUEST';
export const REMOVE_TIMELINE_SUCCESS = 'REMOVE_TIMELINE_SUCCESS';
export const REMOVE_TIMELINE_ERROR   = 'REMOVE_TIMELINE_ERROR';